

















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import TheProfile from '@/components/Common/TheProfile.vue'
import TheNetworkProfile from '@/components/Common/TheNetworkProfile.vue'
import TheCreditUsage from '@/components/Common/TheCreditUsage.vue'
import TheUsageAlert from '@/components/Common/TheUsageAlert.vue'
import TheAppSwitch from '@/components/Common/TheAppSwitch.vue'
import { SUBSCRIPTION_STATUS } from '@/constants/subscription'
import * as Sentry from '@sentry/vue'
import LoginButton from '@/components/Common/LoginButton.vue'
import SignupButton from '@/components/Common/SignupButton.vue'
import adoriLogo from '@/assets/adori-without-text.svg'
import { useGetBillingSummary } from '@/hooks/billing'
import get from 'lodash.get'
import { formatTimeAgo } from '@/utils/time'

@Component({
  components: {
    TheProfile,
    TheNetworkProfile,
    TheCreditUsage,
    LoginButton,
    SignupButton,
    TheUsageAlert,
    TheAppSwitch,
  },
  setup() {
    const { data: summaryData, isLoading: isSummaryLoading } = useGetBillingSummary({
      enabled: true,
    })
    return {
      summaryData,
    }
  },
})
export default class TheHeader extends Vue {
  @Getter currentNetworkSubscriptions!: any
  @Getter networkId!: any
  @Getter networkType!: any
  @Getter isYoutube!: Boolean
  @Getter isStudio!: Boolean
  @Getter isVideo!: Boolean
  @Getter selectedProduct!: string

  countdown = ''

  created() {
    if (['ADORI_DAY_PASS_1', 'ADORI_DAY_PASS_2'].includes(this.networkType) && this.cancelAt) {
      setTimeout(() => {
        this.getCountdown()
      }, 1000)
    }
  }

  get isUsageAllowed() {
    return ['YOUTUBE_METERED', 'YOUTUBE_PRO'].includes(this.networkType)
  }
  get isNewUsage() {
    return this.isVideo
  }

  get planDetails() {
    return get(this, 'summaryData', null)
  }

  get cancelAt() {
    return this.planDetails?.cancel_at === null ? this.planDetails?.current_period_end : false
  }

  get isFree() {
    return this.networkType == 'VIDEO_FREE' ? true : false
  }

  isPath(path: string) {
    return this.$router.currentRoute.fullPath === path
  }

  isPathRegex(regex: RegExp) {
    return regex.test(this.$router.currentRoute.fullPath)
  }

  get logoSrc() {
    return adoriLogo
  }

  get permissionError() {
    if (this.isPath('/permission-error')) {
      return true
    }
    return false
  }

  get isReferAllowed() {
    //@ts-ignore
    return this.networkType === 'YOUTUBE_METERED' && window.growsurf
  }

  get hasSubscriptions() {
    if (this.isPath('/plans')) {
      if (!this.$permissions.isManageNetworkBillingAllowed()) return true
      const subs: any = this.currentNetworkSubscriptions
      if (subs && !subs.hasUpgraded) return true
      if (
        subs &&
        subs.subscription &&
        (subs.subscription.status === SUBSCRIPTION_STATUS.trial ||
          subs.subscription.status === SUBSCRIPTION_STATUS.active)
      ) {
        return true
      }
      return false
    }
  }

  @Watch('cancelAt')
  handle() {
    if (['ADORI_DAY_PASS_1', 'ADORI_DAY_PASS_2'].includes(this.networkType)) {
      setTimeout(() => {
        this.getCountdown()
      }, 1000)
    }
  }

  handleRoute() {
    this.isYoutube
      ? this.selectedProduct === 'BLOG'
        ? this.$router.push('/home/blog')
        : this.$router.push('/home')
      : this.$router.push('/overview')
  }

  gotoHelp() {
    window.open(`https://adoriai.com/documentation/get-started-how-to-convert-blog-to-video`, '_blank')
  }

  bookDemo() {
    // @ts-ignore
    if (window.Calendly) {
      // @ts-ignore
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/adoriai-support/30min',
      })
    } else {
      console.error('Calendly script not loaded')
    }
  }

  getCountdown() {
    const now = new Date().getTime()
    const cancelTime = new Date(this.cancelAt).getTime()
    const remainingTime = cancelTime - now

    if (remainingTime <= 0) {
      this.countdown = ''
      return // Stop here, don't call setTimeout again
    }

    //   const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000)

    this.countdown = ` ${hours}h ${minutes}m ${seconds}s`

    setTimeout(() => {
      this.getCountdown()
    }, 1000)
  }

  feedback() {
    Sentry.captureMessage('FEEDBACK')
  }

  openGrowSurf() {
    //@ts-ignore
    growsurf.open()
  }
}
